import { useNavigate } from "react-router-dom";
import { Martini, Mic, UtensilsCrossed, Music, Ticket, BedDouble } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const CATEGORY_ICONS = { Martini, Mic, UtensilsCrossed, Music, Ticket, BedDouble };

export const CategoryChip = ({ category }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const Icon = CATEGORY_ICONS[category.icon] || Martini;
  return (
    <button
      type="button"
      data-testid={`category-chip-${category.key}`}
      onClick={() => navigate(`/explorer?categorie=${category.key}`)}
      className="flex shrink-0 snap-start items-center gap-2 rounded-full border border-slate-100 bg-white px-5 py-2.5 text-sm font-semibold text-slate-800 shadow-[0_4px_16px_rgba(15,23,42,0.06)] transition duration-300 hover:-translate-y-0.5 hover:border-blue-200 hover:shadow-[0_10px_24px_rgba(37,99,235,0.14)]"
    >
      <Icon className="h-4 w-4" style={{ color: category.color }} />
      {t(category.label)}
    </button>
  );
};
